import { store } from '@/decorators/store';
import { Vehicle } from '@/entities/Vehicle';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'VehicleStore' })
export class VehicleStore extends AbstractEntityStore<Vehicle> {
  protected entityIdKey = 'vehicleId';
  protected entityValueKey = 'vehicleName';
}
